import { jsxs as v, jsx as l } from "react/jsx-runtime";
import { E as d, S as H } from "./icons.types-0722eef5.js";
function g({ title: n, titleId: h, size: a, width: t, height: o, extended: r = !1, ...s }) {
  const i = r ? d : H, e = a ? i[a] : t || i[r ? "s" : "l"], c = a ? i[a] : o || i[r ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: e,
      height: c,
      "aria-labelledby": h,
      ...s,
      children: [
        n ? /* @__PURE__ */ l("title", { id: h, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Print_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M61.901 1.5a8.6 8.6 0 0 1 8.564 7.816l.035.782v51.803a8.6 8.6 0 0 1-7.816 8.564l-.782.035H10.099a8.6 8.6 0 0 1-8.564-7.816l-.035-.782V12.114h10.615v-2.017a8.6 8.6 0 0 1 7.816-8.563l.783-.035h41.188Zm0 5.308H20.715a3.291 3.291 0 0 0-3.255 2.804l-.036.486v46.428a2.654 2.654 0 0 1-5.265.477l-.043-.477V17.423H6.808v44.478a3.291 3.291 0 0 0 2.804 3.256l.486.035h51.803a3.291 3.291 0 0 0 3.256-2.804l.035-.486V10.099a3.292 3.292 0 0 0-2.804-3.256l-.486-.035Zm-4.67 39.807a2.654 2.654 0 0 1 .477 5.265l-.477.043H25.385a2.654 2.654 0 0 1-.477-5.265l.477-.043H57.23Zm0-10.615a2.654 2.654 0 0 1 .477 5.265l-.477.043H25.385a2.654 2.654 0 0 1-.477-5.265l.477-.043H57.23Zm0-10.615a2.654 2.654 0 0 1 .477 5.264l-.477.043H46.615a2.654 2.654 0 0 1-.477-5.265l.477-.042h10.616ZM38.335 14.769a2.972 2.972 0 0 1 2.973 2.972v9.979a2.972 2.972 0 0 1-2.973 2.972h-9.978a2.972 2.972 0 0 1-2.972-2.972v-9.979a2.972 2.972 0 0 1 2.972-2.972h9.978Zm18.896 0a2.654 2.654 0 0 1 .477 5.265l-.477.043H46.615a2.654 2.654 0 0 1-.477-5.265l.477-.043h10.616Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Print_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as Print
};
